<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row id="articles-list">
        <v-col>
          <span class="text-tcdc-green bold header text-uppercase">{{$t('article.article')}}</span>
        </v-col>
      </v-row>
      <v-layout wrap mt-5 v-if="articleCategories && articleCategories.length > 0">
        <v-chip
            color="#34A93E"
            :outlined="mode !== 'all'"
            :class="{'active-cate': mode === 'all'}"
            class="mb-3 mr-2"
            @click="changePage(1)"
        >
          All
        </v-chip>
        <v-chip
            v-for="(item, i) in articleCategories"
            :key="i"
            color="#34A93E"
            :outlined="mode !== item.category_id"
            :class="{'active-cate': mode === item.category_id}"
            class="mb-3 mr-2"
            @click="changePage(1, item.category_id)"
        >
          {{item['cate_name_'+lang]}}
        </v-chip>
      </v-layout>
    </template>

    <div v-if="allArticles && allArticles.length > 0">
      <v-row class="mt-5">
        <template v-for="item of allArticles">
          <v-col cols="12" :md="item.highlight ? 12 : 6" :key="item.id.toString()">
            <span v-if="lang=='en' && item[`subject_en`]=='' ||item[`subject_en`]==null">
               <ArticleCard
                   class="cursor-pointer"
                   :image="item.cover_img_path"
                   :title="item[`subject_th`]"
                   :description="item[`intro_th`]"
                   :date="item[`article_date_${lang}`]"
                   :viewer="item.article_view"
                   @click.native="articleDetailhandler(item.article_id, item.slug)"
               />
            </span>
            <span v-else-if="lang=='th' && item[`subject_th`]==''||item[`subject_th`]== null ">
               <ArticleCard
                   class="cursor-pointer"
                   :image="item.cover_img_path"
                   :title="item[`subject_en`]"
                   :description="item[`intro_en`]"
                   :date="item[`article_date_${lang}`]"
                   :viewer="item.article_view"
                   @click.native="articleDetailhandler(item.article_id, item.slug)"
               />
            </span>
            <span v-else>
               <ArticleCard
                   class="cursor-pointer"
                   :image="item.cover_img_path"
                   :title="item[`subject_${lang}`]"
                   :description="item[`intro_${lang}`]"
                   :date="item[`article_date_${lang}`]"
                   :viewer="item.article_view"
                   @click.native="articleDetailhandler(item.article_id, item.slug)"
               />
            </span>

          </v-col>
        </template>
      </v-row>
      <v-row class="mt-8">
        <v-col class="d-flex flex-1 align-center justify-end">
          <v-pagination
                  v-if="articlePages"
                  total-visible="7"
                  v-model="articlePages.current_page"
                  :length="articlePages.last_page"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  color="#2e8037"
                  @input="(event) => {changePage(event, mode); $vuetify.goTo('#articles-list');}"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <div v-else class="grey--text my-5">
      <div class="text-center">
        {{$t('article.noAnyItem')}}
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from "../../components/cards/ArticleCard";
import GreenLabel from "../../components/buttons/GreenButton";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import {Utils} from "@/util/Utils";

export default {
  components: {
    ArticleCard,
    Loading
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    let res = await this.$store.dispatch('Article/onGetAllCategories')
    if (res) {
      // remove category name = E-Book
      for (const x of res) {
        if (x.cate_name_en === 'E-Book') {
          res = res.filter(item => item.cate_name_en !== x.cate_name_en)
          break
        }
      }
      this.articleCategories = res
    }
    // console.log('where ??? ', this.isLoading)
    if (!this.articlePages) {
      this.isLoading = true;
      await this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang })
              .then( ()=>{
                this.isLoading = false;
              }
      ).catch(err => console.log(err));
    }
    // this.isLoading = false;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      articlePages: state => state.Article.allArticles,
      allArticles: state => {
        if (state.Article.allArticles) {
          return state.Article.allArticles.data
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  methods: {
    articleDetailhandler(id, slug) {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}`+`${branch}/service/resource-center/article/${id}-${slug}`);
    },
    changePage(page, mode = 'all') {
      this.isLoading = true;
      this.mode = mode
      if (mode === 'all') mode = ''
      this.$store.dispatch('Article/onGetAllArticles', {
        page: page,
        lang: this.lang,
        category_id: mode
      }).then(()=>{
        this.isLoading = false;
      });
    }
  },
  data: () => ({
    isLoading: false,
    mode: 'all', // all categories
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        disabled: false,
        href: "/:branch/service/resource-center"
      },
      {
        text: "ARTICLE",
        disabled: true
      }
    ],
    articleCategories: []
  })
};
</script>

<style>
.active-cate {
  color: #fff !important;
}
</style>
